<template>
  <v-card class="mb-3" style="border-radius: 10px;">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 pa-0 text-xs-left text-sm-right px-1>
          <span @click="downloadCsv" class="nowrap subtitle rounded-chip mr-3">
            Download CSV
          </span>
          {{i18n('Registros')}}: {{config.records.length}}
        </v-flex>
        <v-flex xs12 pa-0 pb-0>
          <v-text-field v-model="filter" class="search-filter" append-icon="search"></v-text-field>
        </v-flex>

        <exchange :is_admin="is_admin" :record="record" @onRemove="onRemove" @onApprove="onApprove" v-for="record in config.records" :key="record.id" />

      </v-layout>
    </v-container>
    <v-card-actions>
      <v-layout column>
        <v-flex xs12>
          <v-btn v-if="showMoreBtn" block dark class="ma-0 btn-style" @click="requestMoreRecords">
            EXIBIR MAIS
          </v-btn>
          <v-btn v-if="config.selectable" block dark class="ma-0 btn-style--secondary mt-2" @click="selectableBtnClick" >
            {{config.selectable.btn_title}}
          </v-btn>
          <v-btn v-if="config.actionable" block dark class="ma-0 btn-style--tertiary mt-2" @click="actionableBtnClick" >
            {{config.actionable.btn_title}}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>
<script>
import ExchangeItem from "./ExchangeItem"
import utils from "./shared/Utils"

export default {
  name: 'ExchangeList',
  components: { 'exchange': ExchangeItem },
  props: {
    config: {
      type: Object
    },
    is_admin: {
      type: Boolean
    }
  },
  data() {
    return {
      filter: '',
      lastId: null
    }
  },
  computed: {
    showMoreBtn() {
      return this.config.records.length > 0 &&
             this.config.loading === false &&
             this.config.lastPageLoaded
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    removeRecord(record) {
      this.config.records.splice(this.config.records.findIndex(el => el.id === record.id), 1)
      this.$emit('onExchangeRemoved')
    },
    requestMoreRecords(e) {
      if (this.config.loading == false) {
        this.$emit('loadMoreRecords', this.getLastRecordId())
      }
    },
    getLastRecordId() {
      let lastId = this.config.records.length - 1
      return this.config.records[lastId]['id']
    },
    onRemove(record) {
      let successCallback = (response) => {
        if (response.body.data || response.status === 204) {
          this.removeRecord(record)
        } else {
          console.log(response)
        }
      }

      let errorCallback = (response) => {
        console.log(response)
      }

      const token = this.$cookies.get('api_token')
      let url = ''
      if(this.is_admin) {
        url = `${this.$root.urls.admin_exchanges}${record.id}`
      }
      else {
        url = `${this.$root.urls.customer__exchanges}/${record.id}`
      }
      this.$http.delete(url, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    onApprove(record) {
      let successCallback = (response) => {
        if (response.body.data) {
          this.removeRecord(record)
          this.config.records.unshift(response.body.data)
          this.$set(this.config, 'records', this.config.records)
        } else {
          console.log(response)
        }
      }

      let errorCallback = (response) => {
        console.log(response)
      }

      const token = this.$cookies.get('api_token')
      this.$http.put(`${this.$root.urls.admin_exchanges}${record.id}/approve`, {}, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    selectableBtnClick() {
      this.config.selectable.btn_action()
    },
    actionableBtnClick() {
      this.config.actionable.btn_action()
    },
    downloadCsv() {
      let parseDate = (d) => {
        const splitted = d.split('T')
        const date = splitted[0]
        const time = splitted[1].split('.')[0]
        return date + ' ' + time
      }

      const header_line = [
        'DATE',
        'EXCHANGE_ID',
        'CURRENCY',
        'EXCHANGE_CURRENCY',
        'VALUE',
        'EXCHANGED_VALUE',
        'EXCHANGE_RATE_SPOT',
        'EXCHANGE_RATE',
        'IOF_RATE',
        'IOF_VALUE',
        'FX_RATE',
        'FX_VALUE',
        'IS_AUTOMATIC',
        'APPROVED_BY',
        'TO_BANK_ACCOUNT',
        'TO_BANK_ACCOUNT_OWNER_NAME',
        'TO_BANK_ACCOUNT_OWNER_DOCUMENT',
        'TO_BANK_ACCOUNT_ID',
        'PARTNER',
        'PARTNER_ID'
      ];

      const rows = this.config.records.reduce((rows, exchange) => {
        const toBankAccount = exchange.to_bank_account || {};
        const toCompany = toBankAccount.company || {};
        const bankTransaction = (exchange.bank_transactions && exchange.bank_transactions[0]) || {};
        const socialName = toCompany.social_name || ''
        const partnerName = bankTransaction.company_name || ''

        const row = [
          parseDate(exchange.inserted_at),
          exchange.id || '',
          exchange.currency || '',
          exchange.exchange_currency || '',
          utils.parseCommaField(exchange.value),
          utils.parseCommaField(exchange.exchanged_value),
          utils.parseCommaField(exchange.exchange_rate_spot),
          utils.parseCommaField(exchange.exchange_rate),
          utils.parseCommaField(exchange.iof_rate),
          utils.parseCommaField(exchange.iof_value),
          utils.parseCommaField(exchange.fx_rate),
          utils.parseCommaField(exchange.fx_value),
          exchange.is_automatic,
          exchange.approved_by ? exchange.approved_by.email || '' : '',
          utils.parseCommaField(utils.longAccountName(toBankAccount)),
          utils.parseCommaField(socialName.toUpperCase()),
          utils.parseCommaField(toCompany.document_number) || '',
          toBankAccount.id || '',
          utils.parseCommaField(partnerName.toUpperCase()),
          bankTransaction.company_id || ''
        ];

        rows.push(row);
        return rows;
      }, [header_line]);

      utils.exportToCsv('exchanges_report.csv', rows, ';');
    }
  }
}
</script>
<style>
  .search-filter .v-icon {
    color: #CCC!important;
  }
  .search-filter .v-text-field__slot input {
    color: #AAA!important;
  }
</style>



// WEBPACK FOOTER //
// src/ExchangeList.vue